<template>
  <div class="object-types">
    <object-types-new
      maxWidth="400px"
      maxHeight="100vh"
      :show="isAppended"
      :systems="systems"
      @close="hideAppendNew"
      @add="addNewTypes"
    ></object-types-new>

    <h3>{{ $t("object_type_title") }}</h3>
    <el-table :data="tableData" v-loading="loading" stripe style="width: 100%;">
      <el-table-column
        prop="code"
        width="155"
        :label="$t('object_type_table_code')"
      ></el-table-column>

      <el-table-column
        prop="name"
        :label="$t('object_type_table_name')"
      ></el-table-column>

      <el-table-column
        prop="type"
        width="130"
        :label="$t('object_type_table_type')"
        :filters="objectTypeName"
        :filter-method="filterType"
        filter-placement="bottom-end"
      >
        <template slot-scope="scope">
          <el-tag
            :type="isPhysical(scope.row.type) ? 'primary' : 'success'"
            disable-transitions
          >
            {{ getName(scope.row.type) }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="used"
        width="250"
        :label="$t('object_type_table_system')"
      >
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.used"
            multiple
            @change="changeSystems(scope.row.id)"
          >
            <el-option
              v-for="item in systems"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
    </el-table>

    <div class="object-types__actions">
      <el-checkbox v-model="showUnused" class="object-types__actions_item">
        {{ $t("object_type_show_unused") }}
      </el-checkbox>

      <el-button
        class="object-types__actions_item"
        type="primary"
        @click="showAppendNew"
      >
        {{ $t("object_type_add") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import ObjectTypesNew from "./object-types__new/ObjectTypesNew.vue";

import * as service from "@/domain/settings/objectTypes.service";
import { PHYSICAL, VIRTUAL } from "@/domain/object.types";

export default {
  name: "ObjectTypes",
  components: {
    ObjectTypesNew
  },
  props: {
    items: Array,
    systems: Array,
    loading: Boolean
  },
  data() {
    return {
      showUnused: false,
      isAppended: false
    };
  },
  computed: {
    tableData() {
      if (this.items && this.items.length > 0) {
        return service.getTableData(this.items, this.showUnused);
      }
      return [];
    },
    objectTypeName() {
      return [
        { text: this.$t("object_type_physical"), value: PHYSICAL },
        { text: this.$t("object_type_virtual"), value: VIRTUAL }
      ];
    }
  },
  methods: {
    filterType(value, row) {
      return row.type === value;
    },
    getName(type) {
      let item = this.objectTypeName.find(t => t.value == type);
      if (item) {
        return item.text;
      }
      return type;
    },
    isPhysical(type) {
      return type === PHYSICAL;
    },
    hideAppendNew() {
      this.isAppended = false;
    },
    showAppendNew() {
      this.isAppended = true;
    },
    addNewTypes(obj) {
      this.$emit("create", service.prepareToSave(obj));
    },
    changeSystems(id) {
      return this.$emit("update", service.prepareToChange(this.tableData, id));
    }
  }
};
</script>

<style lang="scss">
@import "@/css/variables.scss";

.object-types {
  width: 100%;
  height: 100%;
  position: relative;

  .object-types__actions {
    position: sticky;
    bottom: -5px;
    margin-top: 10px;
    padding: 10px 0;
    text-align: right;
    width: 100%;
    background-color: $free_zone_color;
    z-index: 3;

    .object-types__actions_item {
      margin: 0 10px;
    }
  }
}
</style>
